const {
  REACT_APP_GRAPHQL_ACCESS_KEY,
  REACT_APP_GRAPHQL_URL,
  REACT_APP_SERVICE_URL,
} = process.env;

export function getGraphqlUrl(): string {
  if (!REACT_APP_GRAPHQL_URL)
    throw Error("Environment variable REACT_APP_GRAPHQL_URL is not configured");

  return REACT_APP_GRAPHQL_URL;
}

export function getGraphqlAccessKey(): string {
  if (!REACT_APP_GRAPHQL_ACCESS_KEY)
    throw Error(
      "Environment variable REACT_APP_GRAPHQL_ACCESS_KEY is not configured"
    );

  return REACT_APP_GRAPHQL_ACCESS_KEY;
}

export function getServiceUrl(): string {
  if (!REACT_APP_SERVICE_URL)
    throw Error("Environment variable REACT_APP_SERVICE_URL is not configured");

  return REACT_APP_SERVICE_URL;
}
